import api from "../services/axios";

class ServiceProducts {
  async saveProducts(dataProducts) {
    const { data } = await api.post('/products', dataProducts)
    return data.id
  }

  async updateProducts(dataProducts) {
    await api.put(`/products/${dataProducts.id}`, dataProducts)
  }

  async getProductsForSelectBox() {
    const { data } = await api.get("/products");
    return data
  }

  async saveProductsFromXml(dataProducts) {
    const adjustedProducts = dataProducts.map((e) => {
      return {
        id: e.id,
        nome: e.nome[0],
        valor: e.valor[0],
        valorVenda: e.valorVenda,
        unidade: e.unidade[0],
        estoque: e.estoque[0],
        descricao: null,
        codBarras: null,
        codReferencia: null,
        estoqueMin: 0
      }
    })

    await api.post('/products', adjustedProducts)
  }

  async getProductById(idProduct) {
    const { data } = await api.get(`/products/${idProduct}`);
    return data
  }

  async findCestGrupBy() {
    const { data } = await api.get('/products/list/cest')
    return data
  }

  async findNcmGrupBy() {
    const { data } = await api.get('/products/list/ncm')
    return data
  }

  async onlyForPesticides() {
    const { data } = await api.get('/products/only/pesticides')
    return data
  }

  async findByName(nome) {
    const name = encodeURIComponent(nome)
    const { data } = await api.get(`/products/find/by/name?name=${name}`)
    return data
  }

  async findStock(id) {
    const { data } = await api.get(`/products/find/stock/${id}`)
    return data
  }

  async stockAdjustment(data) {
    await api.post('/products/stock', data)
  }

  async fillCombobox() {
    const { data } = await api.get('/products')
    return data
  }

  async fillComboBoxWithPaginate(id = '', text = '', filterType = 'includes', page = 1, tipoProduto = 'normal') {
    const { data } = await api.get(
      `/products/combobox/with/paginate?id=${id}&q=${encodeURIComponent(text)}&page=${page}&filterType=${filterType}&tipoProduto=${tipoProduto}`
    );

    return data
  }

  async findLotes(idAgrotoxico = '', embalagem = '', registroAgrotox = '', lote = '') {
    const { data } = await api.get(`/products/list/lotes?idAgrotoxico=${idAgrotoxico}&embalagem=${embalagem}&registroAgrotox=${registroAgrotox}&lote=${lote}`);
    return data;
  }

  async findPesticide(idAgrotoxico = '', embalagem = '', registroAgrotox = '', lote = '') {
    const { data } = await api.get(`/products/find/pesticide?idAgrotoxico=${idAgrotoxico}&embalagem=${embalagem}&registroAgrotox=${registroAgrotox}&lote=${lote}`);
    return data;
  }

  async findPerRegister(registroAgrotox) {
    const { data } = await api.get(`/products/per/register?registroAgrotox=${registroAgrotox}`);
    return data;
  }
}

export default new ServiceProducts